import { render, staticRenderFns } from "./PropertyExpiry.vue?vue&type=template&id=36689254"
import script from "./PropertyExpiry.vue?vue&type=script&lang=js"
export * from "./PropertyExpiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports